var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.3,5 C14.459798,5 15.4,5.94020203 15.4,7.1 L15.4,13.3 C15.4,14.459798 14.459798,15.4 13.3,15.4 L7.1,15.4 C5.94020203,15.4 5,14.459798 5,13.3 L5,7.1 C5,5.94020203 5.94020203,5 7.1,5 Z M13.3,6.4 L7.1,6.4 C6.71340068,6.4 6.4,6.71340068 6.4,7.1 L6.4,13.3 C6.4,13.6865993 6.71340068,14 7.1,14 L13.3,14 C13.6865993,14 14,13.6865993 14,13.3 L14,7.1 C14,6.71340068 13.6865993,6.4 13.3,6.4 Z M8.31538462,3.55271368e-15 C9.41662932,3.55271368e-15 10.3184302,0.85392065 10.3947659,1.93574067 L10.4,2.08461538 L10.4,2.77692308 C10.4,3.1635224 10.0865993,3.47692308 9.7,3.47692308 C9.34561729,3.47692308 9.05274177,3.21357945 9.00639017,2.87190893 L9,2.77692308 L9,2.08461538 C9,1.74088572 8.74668368,1.45632124 8.41655206,1.40742299 L8.31538462,1.4 L2.08461538,1.4 C1.74088572,1.4 1.45632124,1.65331632 1.40742299,1.98344794 L1.4,2.08461538 L1.4,8.31538462 C1.4,8.65911428 1.65331632,8.94367876 1.98344794,8.99257701 L2.08461538,9 L2.77692308,9 C3.1635224,9 3.47692308,9.31340068 3.47692308,9.7 C3.47692308,10.0543827 3.21357945,10.3472582 2.87190893,10.3936098 L2.77692308,10.4 L2.08461538,10.4 C0.983370676,10.4 0.0815698218,9.54607935 0.00523410421,8.46425933 L3.55271368e-15,8.31538462 L3.55271368e-15,2.08461538 C3.55271368e-15,0.983370676 0.85392065,0.0815698218 1.93574067,0.00523410421 L2.08461538,3.55271368e-15 L8.31538462,3.55271368e-15 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/primary",
    transform: "translate(4.300000, 4.300000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.300000, -4.300000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a3dc7327132cff4b58faf212ae2c38e1.svg";
export { ForwardRef as ReactComponent };